import { useAuth } from "../../lib/hooks/use-auth";

/**
 * Sprint 14g — true iff the current user owns the active workspace. Backs the
 * `canDelete` gate on PanelRowMenu (members archive; only owners hard-delete).
 * Mirrors the inline idiom already used in CockpitHeader / MembersPage.
 */
export function useIsOwner(): boolean {
  const { user, currentWorkspaceId } = useAuth();
  return user?.workspaces.find((w) => w.id === currentWorkspaceId)?.role === "owner";
}
